import React, { useState, useEffect } from 'react';
import { Col, message, Popover, Row, Space, theme } from 'antd';
import styles from './styles.module.scss';
import { BaseUrlGeneral } from '../../../../utils';
import SkillEditModal from '../edit-skill';
import DeleteModal from '../../../general/modal/delete';
import axiosInstance from '../../../../axios_instance';
import { SkillCategoryMapping } from '../../../../utils/object';

export interface SkillProps {
  skill: {
    skill_id: number;
    skill_name: string;
    skill_type: {
      id: number;
      name: string;
    };
    skill_category: Array<{
      id: number;
      name: string;
    }>;
  };
}

const Skill: React.FC<SkillProps> = ({ skill }: SkillProps): JSX.Element => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const handleDelete = () => {
    axiosInstance
      .delete('/api/v1/skills/' + skill['skill_id'])
      .then((response) => {
        setOpenDeleteModal(false);
        message.success(`Skill deleted successfully`);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <SkillEditModal
        key={skill['skill_id']}
        {...{
          skill_id: skill['skill_id'],
          skill_name: skill['skill_name'],
          skill_type: skill['skill_type'],
          skill_category: skill['skill_category'],
          setIsModalOpen: setOpenEditModal,
          isModalOpen: openEditModal,
        }}
      />
      <DeleteModal
        {...{
          handleDelete: handleDelete,
          setIsModalOpen: setOpenDeleteModal,
          isModalOpen: openDeleteModal,
        }}
      />
      <Row key={skill['skill_id']} className={styles.row}>
        <Col span={6}>
          <div
            style={{
              marginTop: '27px',
              wordWrap: 'break-word',
              marginRight: '10px',
              marginLeft: '15px',
            }}
          >
            <p className={styles.text}>{skill['skill_name']}</p>
          </div>
        </Col>
        <Col span={6}>
          <div
            style={{
              marginTop: '27px',
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles.text}>
              {skill['skill_type']['id'] === 1 ? 'Core Skill' : 'Soft Skill'}
            </p>
          </div>
        </Col>
        <Col span={10} style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles['skill-text']}>
              {skill['skill_category'].slice(0, 3).map((category: any, index: number) => {
                return (
                  <Space className={styles['skill-box']} key={index}>
                    {SkillCategoryMapping[category['name']] || category['name']}
                  </Space>
                );
              })}

              <Space style={{ cursor: 'pointer' }}>
                <Popover
                  placement="bottom"
                  title={'Category'}
                  content={skill['skill_category'].map((category: any, index: number) => {
                    return (
                      <Space className={styles['skill-box']} key={index}>
                        {category['name']}
                      </Space>
                    );
                  })}
                >
                  {skill['skill_category'].length > 3 ? '... View more' : ''}
                </Popover>
              </Space>
            </p>
          </div>
        </Col>
        <Col span={2}>
          <div
            style={{
              display: 'inline-block',
              marginTop: '20px',
              wordWrap: 'break-word',
              marginRight: '5px',
              cursor: 'pointer',
              position: 'relative',
            }}
            className={styles['action']}
            onClick={() => {
              setOpenEditModal(true);
            }}
          >
            <img
              src="/edit.png"
              style={{ left: '7px', top: '6px', position: 'absolute' }}
            />
            {/* <img src="/delete.png" style={{right:"5px",top:"5px",position:"absolute"}}/> */}
          </div>
          <div
            style={{
              display: 'inline-block',
              marginTop: '20px',
              wordWrap: 'break-word',
              marginRight: '10px',
              cursor: 'pointer',
              position: 'relative',
            }}
            className={styles['action']}
            onClick={() => {
              setOpenDeleteModal(true);
            }}
          >
            {/* <img src="/edit.png" style={{left:"5px",top:"5px",position:"absolute"}}/> */}
            <img
              src="/delete.png"
              style={{ right: '8px', top: '6px', position: 'absolute' }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Skill;
